export const SITE = {
  name: 'NioDelta',
  tagline: 'Crafted, not templated.',
  email: 'hello@niodelta.com',
  phone: '+91-90678-20204',
  whatsapp: 'https://wa.me/+919067820204',
  location: 'Pune · Mumbai · Nashik',
  socials: [
    { label: 'WhatsApp', href: 'https://wa.me/+919067820204' },
    { label: 'Instagram', href: 'https://instagram.com/niodelta' },
    { label: 'LinkedIn', href: 'https://linkedin.com/company/niodelta' },
    { label: 'X / Twitter', href: 'https://x.com/niodelta' },
    { label: 'Dribbble', href: 'https://dribbble.com/niodelta' },
  ],
};

export const SERVICES = [
  {
    slug: 'website-development',
    h1: 'Website Development Company for Maharashtra Businesses',
    num: '01',
    title: 'Website Development',
    short: 'Marketing sites that convert visitors into pipeline.',
    long: 'Hand-built marketing sites and content platforms with fast load, intentional motion, and editorial typography. Built on modern stacks—React, Next.js, Astro—shipped headless when it matters.',
    deliverables: ['Design system', 'CMS-ready pages', 'SEO foundation', 'Analytics & A/B'],
    accent: '#6C5CE7',
  },
  {
    slug: 'web-app-development',
    h1: 'Web Application Development Company in Pune & Mumbai',
    num: '02',
    title: 'Web App Development',
    short: 'Dashboards, portals and tools that feel inevitable.',
    long: 'From auth to async workflows, we engineer reliable web apps. TypeScript, FastAPI, Postgres / Mongo, and queue-driven backends with proper observability.',
    deliverables: ['Auth & RBAC', 'Realtime data', 'Admin panels', 'API design'],
    accent: '#4B9FFF',
  },
  {
    slug: 'mobile-app-development',
    h1: 'Mobile App Development Company for Android & iOS',
    num: '03',
    title: 'Mobile App Development',
    short: 'Native-feel iOS and Android, one codebase.',
    long: 'React Native and Expo apps with native modules where it counts. Offline-first sync, push, in-app payments and shipping to both stores in weeks—not quarters.',
    deliverables: ['iOS + Android', 'Push notifications', 'Offline sync', 'Store submission'],
    accent: '#6C5CE7',
  },
  {
    slug: 'custom-software-development',
    h1: 'Custom Software Development Company in Pune & Mumbai',
    num: '04',
    title: 'Custom Software Development',
    short: 'Bespoke internal tools that pay for themselves.',
    long: 'Custom software glued to the way your team actually works. Quoting tools, CRM extensions, ops dashboards, billing flows—built once, owned forever.',
    deliverables: ['Workflow audit', 'Integration layer', 'Internal tooling', 'Hand-off & training'],
    accent: '#4B9FFF',
  },
  {
    slug: 'ecommerce-website-development',
    h1: 'Ecommerce Website Development in Mumbai, Pune & Nashik',
    num: '05',
    title: 'Ecommerce Website Development',
    short: 'Storefronts engineered for AOV and repeat purchase.',
    long: 'Shopify Hydrogen, Medusa or custom headless—built around your catalog, your margins, and your post-purchase loop. From PDP to checkout to ops.',
    deliverables: ['Headless storefront', 'Payments & GST', 'Catalog architecture', 'Retention loops'],
    accent: '#6C5CE7',
  },
  {
    slug: 'ai-solutions',
    h1: 'AI Development Company in Pune & Mumbai',
    num: '06',
    title: 'AI Solutions',
    short: 'Production AI: RAG, agents, automation that ships.',
    long: 'We integrate LLMs into real product surfaces—search, support, content ops, agents. Eval harnesses, guardrails, cost ceilings, observability. Not a demo.',
    deliverables: ['RAG / search', 'Agentic workflows', 'Evals & guardrails', 'Cost & latency budgets'],
    accent: '#4B9FFF',
  },
];

// Real projects live in data/work.js.
export { WORK } from '@/data/work';

export const PROCESS = [
  { step: '01', title: 'Discover', body: 'A focused two-week sprint. We sit with your team, founder, your numbers. We leave with a brief that is honest about scope.' },
  { step: '02', title: 'Define', body: 'Information architecture, key flows, a system of tokens, a motion language. Decisions get documented—designers and engineers stay in sync.' },
  { step: '03', title: 'Design', body: 'Wireframes graduate to high-fidelity in one continuous file. No giant decks. Real components, real states, real copy.' },
  { step: '04', title: 'Build', body: 'Engineering joins on day one. Performance budgets, accessibility, observability are not bolted on—they are the work.' },
  { step: '05', title: 'Ship & extend', body: 'We launch in weeks, not quarters. Then we stay—as a fractional product partner or for the next chapter.' },
];

export const STATS = [
  { kpi: '47', suffix: '+', label: 'shipped products' },
  { kpi: '8', suffix: ' yrs', label: 'compounded craft' },
  { kpi: '12', suffix: '', label: 'in-house operators' },
  { kpi: '4.9', suffix: '/5', label: 'partner NPS' },
];

export const CLIENTS = ['Staffly', 'Shiksha CRM', 'Foodysh', 'Rupantaram', 'ForexPips'];
